import React, { useContext, useState } from "react";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { useFormik } from "formik";
import { smsApi } from "../../../api/api";
import { AccountContext } from "../../../contexts/AccountContext";
import CancelIcon from "@mui/icons-material/Cancel";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import RefreshIcon from "@mui/icons-material/Refresh";
import SmsIcon from "@mui/icons-material/Sms";
import ConfirmDialog from "../../../common/components/ConfirmDialog";

export const ActiveToolbar = ({ active, search, setSearch, setIsLoading, setHighlightActive, onSearch, onRefresh, onClearSearch, isBusy }) => {
  const { user } = useContext(AccountContext);
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const formik = useFormik({
    initialValues: {
      search: "",
    },
    onSubmit: (fields) => {
      setIsLoading(true);
      setSearch(fields.search);
      onSearch(fields.search)
        .then((res) => {
          setHighlightActive();
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    },
  });

  const refresh = () => {
    setIsLoading(true);
    onRefresh()
      .then((res) => {
        setHighlightActive();
        setSearch("");
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleCancelAll = () => {
    console.log("handleCancelAll called");
    setIsLoading(true);
    smsApi
      .active(user.atsIcaoLocationIndicator)
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <form className="table-toolbar" onSubmit={formik.handleSubmit}>
      <ConfirmDialog
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={() => {
          setConfirmOpen(false);
          handleCancelAll();
        }}
        title={t("confirm_title")}
        message={t("confirm_abortall")}
      />
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Button disabled={isBusy} sx={{ textTransform: "none" }} size="small" onClick={refresh} variant="outlined" startIcon={<RefreshIcon />}>
          {t("refresh")}
        </Button>
        <div style={{ marginLeft: 3, marginRight: 3 }}></div>
        <Button
          sx={{ textTransform: "none" }}
          color="error"
          size="small"
          onClick={() => {
            setConfirmOpen(true);
          }}
          variant="outlined"
          startIcon={<SmsIcon />}
        >
          {t("cancel_all_immediately")}
        </Button>
        {search && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
            <div style={{ marginLeft: 10 }}></div>
            {t("search_results")} "{search}"{" "}
            <IconButton
              size="small"
              aria-label="cancel"
              component="span"
              onClick={() => {
                onClearSearch()
                  .then((res) => {
                    setSearch("");
                  })
                  .catch((err) => {});
              }}
            >
              <CancelIcon />
            </IconButton>
          </div>
        )}
      </div>
      <TextField
        sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: 1, marginTop: 1 }}
        variant="outlined"
        size="small"
        id="search"
        name="search"
        value={formik.values.search}
        onChange={formik.handleChange}
        placeholder={t("search")}
        InputProps={{
          type: "search",
          startAdornment: <SearchIcon fontSize="medium" />,
        }}
      />
    </form>
  );
};
